import React, { useEffect, useState } from 'react';
import { _removeClass, _setText } from '../../controllers/dom';
import Dashboard from './configuration/Dashboard';
import GameInformations from './configuration/GameInformations';
import Menu from './configuration/Menu';
import Buildings from './configuration/buildings/Buildings';
import NewBuilding from './configuration/buildings/NewBuilding';
import ManageBuilding from './configuration/buildings/ManageBuilding';
import Players from './configuration/player/Players';
import ManagePlayer from './configuration/player/ManagePlayer';
import VehicleModels from './configuration/vehicleModels/VehicleModels';
import NewVehicleModel from './configuration/vehicleModels/NewVehicleModel';
import ManageVehicleModel from './configuration/vehicleModels/ManageVehicleModel';
import Skills from './configuration/skills/Skills';
import Ranks from './configuration/ranks/Ranks';
import NewRank from './configuration/ranks/NewRank';
import ManageRank from './configuration/ranks/ManageRank';
import ManageFunction from './configuration/skills/ManageFunction';
import ManageSkill from './configuration/skills/ManageSkill';
import NewFunction from './configuration/skills/NewFunction';
import NewSkill from './configuration/skills/NewSkill';
import Status from './configuration/status/Status';
import ManageStatus from './configuration/status/ManageStatus';
import NewStatus from './configuration/status/NewStatus';
import Services from './configuration/services/Services';
import NewService from './configuration/services/NewService';
import ManageService from './configuration/services/ManageService';
import Sig from './configuration/sig/Sig';
import EditVehicleInBuilding from './configuration/buildings/EditVehicleInBuilding';
import IncidentTypes from './configuration/incidentTypes/IncidentTypes';
import InterventionGroups from './configuration/interventionGroups/InterventionGroups';
import { locales } from '../../translations/locales';

const components = {
    Dashboard,
    GameInformations,
    Players,
    ManagePlayer,
    Buildings,
    ManageBuilding,
    NewBuilding,
    EditVehicleInBuilding,
    VehicleModels,
    NewVehicleModel,
    ManageVehicleModel,
    Skills,
    Ranks,
    NewRank,
    ManageRank,
    ManageFunction,
    ManageSkill,
    NewFunction,
    NewSkill,
    Status,
    ManageStatus,
    NewStatus,
    Services,
    NewService,
    ManageService,
    Sig,
    IncidentTypes,
    InterventionGroups,
};

const Configuration = (props) => {
    const { data, ModuleRP, locale, theme } = props;
    const [activePage, setActivePage] = useState('Dashboard');
    const waitingPlayers = (data.waitingPlayers ? data.waitingPlayers.length : 0);

    const Component = components[activePage];

    useEffect(() => {
        if (activePage === 'NewSkill') {
            _removeClass('bloc-newSkill', 'hide');
        }
        switch (ModuleRP.configActive) {
            case 'NewBuilding':
                setActivePage('Buildings');
                break;
            case 'NewVehicleModel':
                setActivePage('VehicleModels');
                break;
            case 'NewSkills':
            case 'NewFunction':
                setActivePage('Skills');
                break;
            case 'NewStatus':
                setActivePage('Status');
                break;
            case 'NewService':
                setActivePage('Services');
                break;
            case 'NewRank':
                setActivePage('Ranks');
                break;
            default:
                break;
        }
        ModuleRP.configActive = activePage;
        _setText('screenName', `<h4 class="m-1">${locales[locale].config.configure}</h4>`);
    }, [activePage, data]);

    return (
        <div className={`container-fluid p-0 bg-${theme === 'DARK' ? 'dark' : 'light'} configuration d-flex`}>
            <Menu
                locale={locale}
                setActivePage={setActivePage}
                theme={theme}
                ModuleRP={ModuleRP}
                activePage={activePage}
                waitingPlayers={waitingPlayers}
                accessMenu={data.accessMenu}
            />
            <Component
                data={data}
                locale={locale}
                theme={theme}
                setActivePage={setActivePage}
                ModuleRP={ModuleRP}
            />
        </div>
    );
};

export default Configuration;
